import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { BadgeDefinition, BadgeTier } from '@/modules/calendar/model/forecast-game/badges';
import styles from '@/modules/calendar/components/forecast-game/forecast-frenzy.module.scss';

const TIER_CLASS: Record<BadgeTier, string> = {
  bronze: styles.tierBronze,
  silver: styles.tierSilver,
  gold: styles.tierGold,
};

export default function BadgeMedal({
  badge,
  unlocked,
  unique,
  showRequirement = true,
  pinned,
  pinDisabled,
  onTogglePin,
}: {
  badge: BadgeDefinition;
  unlocked: boolean;
  unique?: boolean;
  showRequirement?: boolean;
  pinned?: boolean;
  pinDisabled?: boolean;
  onTogglePin?: () => void;
}) {
  return (
    <OverlayTrigger placement={'top'} overlay={<Tooltip>{badge.description}</Tooltip>}>
      <div
        className={`${styles.medal} ${badge.tier ? TIER_CLASS[badge.tier] : ''} ${
          unique ? styles.uniqueBadge : ''
        } ${unlocked ? '' : styles.medalLocked}`}
      >
        {unlocked && onTogglePin && (
          <button
            type={'button'}
            className={`${styles.pinButton} ${pinned ? styles.pinButtonActive : ''}`}
            disabled={!pinned && pinDisabled}
            title={pinned ? 'Unpin from Overview' : 'Pin to Overview'}
            onClick={e => {
              e.stopPropagation();
              onTogglePin();
            }}
          >
            <FontAwesomeIcon icon={faThumbtack} />
          </button>
        )}
        <div className={styles.medalIcon}>{badge.emoji}</div>
        <div className={`${styles.medalLabel} text-small`}>{badge.label}</div>
        {!unique && showRequirement && (
          <div className={styles.medalRequirement}>{badge.description}</div>
        )}
      </div>
    </OverlayTrigger>
  );
}
